import React from "react";
import {useSelector} from "react-redux";
import {APPLY_STATUS_SUCCESS} from "../actions/ApplyFieldActions";

function useApplyFieldData(fieldName) {
    const applyField = useSelector(state => state.applyField);

    return applyField[fieldName] && applyField[fieldName].status === APPLY_STATUS_SUCCESS ?
        applyField[fieldName].data : {};
}

export default useApplyFieldData;